export const sortBracketStack = (parentBracket, bracketsAll) => {
  let subBrackets = bracketsAll
    .filter((b) => b.subBracketTo === parentBracket.id)
    .sort((a, b) => {
      return a.size - b.size;
    });
  let sortedBrackets = [parentBracket];
  subBrackets.forEach((b) => {
    sortedBrackets = sortedBrackets.concat(sortBracketStack(b, bracketsAll));
  });
  return sortedBrackets;
};
